import { MobileHeaderIconButton } from './MobileHeaderIconButton';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IoNotificationsOutline, IoSettingsOutline, IoPersonOutline } from 'react-icons/io5';
import { useAuth } from '../hooks/useAuth';
import { useAthleteContext } from '../context/AthleteContext';
import { AthleteSwitcher } from '../components/AthleteSwitcher';
import { AddAthleteModal } from '../components/AddAthleteModal';
import { AthleteSettingsModal } from '../components/athlete-settings/AthleteSettingsModal';
import { NotificationBadge } from '../components/NotificationBadge';
import { useNotificationCount } from '../hooks/useNotificationCount';
import logoUrl from '@assets/logo.png';

export function MobileHeader() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const auth = useAuth();
  const { isCoach, athletes, selectedAthleteId, selectAthlete } = useAthleteContext();
  const [showAddAthlete, setShowAddAthlete] = useState(false);
  const [settingsId, setSettingsId] = useState<number | null>(null);
  const { unreadCount } = useNotificationCount();
  const selectedAthlete = athletes.find(athlete => athlete.id === selectedAthleteId);

  return (
    <header className={`mobile-header${isCoach && athletes.length > 0 ? ' mobile-header--compact-coach' : ''}`}>
      <div className="mobile-header__row">
        <div className="mobile-header__brand">
          <img src={logoUrl} alt="VO2" className="mobile-header__logo" />
        </div>

      {isCoach && athletes.length > 0 && (
        <div className="header-athlete-picker">
          <AthleteSwitcher
            athletes={athletes}
            selectedId={selectedAthleteId}
            onChange={selectAthlete}
            onOpenSettings={setSettingsId}
            compact
            triggerContent={<>
              <span className="coach-athlete-card__avatar">
                {selectedAthlete?.profile_image
                  ? <img src={selectedAthlete.profile_image} alt="" />
                  : <IoPersonOutline aria-hidden="true" />}
              </span>
              <span className="coach-athlete-card__identity">
                <strong>{selectedAthlete?.full_name ?? t('athletePicker.title')}</strong>
              </span>

            </>}
          />
        </div>
      )}

        <div className="mobile-header__actions">
          <span id="calendar-header-actions" className="mobile-header__calendar-actions" />
          <MobileHeaderIconButton
            type="button"
            className="mobile-header__icon-btn mobile-header__icon-btn--notif"
            onClick={() => navigate('/notifications')}
            label={
              unreadCount > 0
                ? t('notifications.unreadCount', { count: unreadCount, defaultValue: `${unreadCount} unread notifications` })
                : t('tabs.notifications')
            }
            icon={<>
            <IoNotificationsOutline aria-hidden />
            <NotificationBadge count={unreadCount} className="mobile-header__notif-badge" />
          </>}
          />
          <MobileHeaderIconButton
            type="button"
            className="mobile-header__icon-btn mobile-header__icon-btn--settings"
            onClick={() => navigate('/settings')}
            label={t('tabs.settings')}
            icon={<>
            <IoSettingsOutline aria-hidden />
          </>}
          />
        </div>
      </div>


      {showAddAthlete && (
        <AddAthleteModal
          onClose={() => setShowAddAthlete(false)}
          onSent={() => void auth.refreshProfile()}
        />
      )}
      {settingsId != null && (
        <AthleteSettingsModal
          athleteId={settingsId}
          onClose={() => setSettingsId(null)}
          onSaved={() => void auth.refreshProfile()}
        />
      )}
    </header>
  );
}
